import React from 'react';
import { MARKETING_SITE_URL } from '../../utils/siteHost';

const SpinTaskerLogo = ({
  className = '',
  headingClassName = 'text-2xl font-bold text-green-600 flex items-center',
  linkClassName = 'flex-shrink-0 hover:opacity-90 transition-opacity',
  atClassName = 'text-white mx-0.5 inline-block',
  asLink = true,
  animate = true,
  spinDuration,
  spinPaused = false
}) => {
  const isSpinning = animate && !spinPaused;
  const hasCustomSpin = isSpinning && Number.isFinite(Number(spinDuration)) && Number(spinDuration) > 0;
  const spinClass = !isSpinning ? '' : hasCustomSpin ? '' : 'animate-spin-slow';
  const logo = (
    <h1 className={headingClassName}>
      SpinT
      <span
        key={isSpinning ? (hasCustomSpin ? `spin-${spinDuration}` : 'default') : 'stopped'}
        className={`${atClassName} ${spinClass}`.trim()}
        style={{
          fontSize: '0.67em',
          ...(isSpinning && hasCustomSpin
            ? { animation: `spin-slow ${spinDuration}s linear infinite` }
            : !isSpinning
              ? { transform: 'rotate(0deg)', animation: 'none' }
              : {})
        }}
      >
        @
      </span>
      sker
    </h1>
  );

  if (!asLink) {
    return <div className={className}>{logo}</div>;
  }

  return (
    <a
      href={MARKETING_SITE_URL}
      className={`${linkClassName} ${className}`.trim()}
      aria-label="SpinTasker — početna stranica"
    >
      {logo}
    </a>
  );
};

export default SpinTaskerLogo;
